import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

type LoginWarningProps = {
  warning?: { text: string; email: string } | null;
};

const LoginWarning: FC<LoginWarningProps> = ({ warning }) => {
  const { t } = useTranslate();

  if (!warning) return null;

  return (
    <div className="nk-block-des">
      <p className="mt-5">
        {t(warning.text)}&nbsp;
        <a href={`mailto:${warning.email}`} className="link email-link">
          {warning.email}
        </a>
      </p>
    </div>
  );
};

export default LoginWarning;
